export const INSUFFICIENT_CREDITS_ERROR =
  'Insufficient ArDrive Turbo credits. Top up at https://publish.solanamobile.com/dashboard/settings/preferences';
